/** Shared writing-settings model (kept out of the modal chunk for lazy-loading). */

export const WRITING_SETTING_TONES = [
  "Auto",
  "Formal",
  "Friendly",
  "Humorous",
  "Serious",
  "Inspiring",
  "Neutral",
  "Sympathetic",
  "Professional",
] as const;

export const WRITING_SETTING_STYLES = [
  "Auto",
  "Concise",
  "Descriptive",
  "Academic",
  "Journalistic",
  "Conversational",
  "Poetic",
  "Technical",
  "Narrative",
  "Formal",
  "Informal",
] as const;

export const WRITING_SETTING_PURPOSES = [
  "Auto",
  "Inform",
  "Persuade",
  "Entertain",
  "Educate",
  "Inspire",
  "Express Emotion",
  "Analyze",
] as const;

export const WRITING_SETTING_CREATIVITY = ["steady", "sharp", "bold"] as const;

export type WriteCreativityOption = (typeof WRITING_SETTING_CREATIVITY)[number];

export const CREATIVITY_LABEL: Record<WriteCreativityOption, string> = {
  steady: "Steady",
  sharp: "Sharp",
  bold: "Bold",
};

export const CREATIVITY_PROMPT_INSTRUCTION: Record<WriteCreativityOption, string> = {
  steady: "Stay close to the original phrasing; minimal embellishment.",
  sharp: "Balanced rewrite; tighten and clarify.",
  bold: "Take creative liberty; rework structure and voice freely.",
};

export type WriteToneOption = (typeof WRITING_SETTING_TONES)[number];
export type WriteStyleOption = (typeof WRITING_SETTING_STYLES)[number];
export type WritePurposeOption = (typeof WRITING_SETTING_PURPOSES)[number];

export interface WritingSettings {
  contentLength: number;
  tone: WriteToneOption;
  creativity: WriteCreativityOption;
  style: WriteStyleOption;
  purpose: WritePurposeOption;
}

export const DEFAULT_WRITING_SETTINGS: WritingSettings = {
  contentLength: 300,
  tone: "Auto",
  creativity: "sharp",
  style: "Auto",
  purpose: "Auto",
};
